/* eslint-disable react/prop-types */

import { YMInitializer } from "react-yandex-metrika/src";
import { TARGET_LANGUAGE } from "../../../config/i18n";
import { ProductProvider } from "../../contexts/ProductContext";
// eslint-disable-next-line import/no-cycle
import { LocaleProvider } from "../../contexts/LocaleContext";

const YM_ACCOUNT_RU = 98321419;
const isRuBuild = TARGET_LANGUAGE === "ru";
const isDevelopment = process.env.NODE_ENV === "development";

const PageContextWrapper = ({
  children,
  pageContext: { locale, siteLanguage, localePath },
}) => (
  <LocaleProvider
    siteLanguage={siteLanguage}
    locale={locale}
    localePath={localePath}
  >
    <ProductProvider>
      <>
        {children}
        {!isDevelopment && isRuBuild && (
          <YMInitializer
            accounts={[YM_ACCOUNT_RU]}
            options={{
              webvisor: true,
              defer: true,
              clickmap: true,
            }}
          />
        )}
      </>
    </ProductProvider>
  </LocaleProvider>
);

export { PageContextWrapper };
